// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"iMIn+","rc-tabs-tab-active":"ZaGmQ","input-suffix":"Qh3Yk","nav-item":"_3sXRf"};